import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const logo: AdminBlockTypeAttribute = {
  label: 'Show logo',
  key: 'logo',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default logo;
